import React from 'react';

import {
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import NumberInput from '../../layout/inputFields/NumberInput';
import InfoPopover from '../../layout/InfoPopover';
import Label from '../../../customFields/Label';

import { timePeriodChoices } from '../../../constants/timePeriods';

const DetectNewIp = () => (
  <Grid size={12}>
    <Grid container gap={1}>
      <Grid size={12}>
        <Label
          variant="label"
          title="New IP period"
          info="The period within which an IP is considered new. If the IP was first seen within this period relative to the transaction date, the rule triggers."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.newIpPeriod.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(0)]}
          popups={(
            <InfoPopover title="New IP period length" content="How long an IP is considered new after first being seen for this entity." />
          )}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.newIpPeriod.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Unit"
          validate={[required()]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default DetectNewIp;
